import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { AsyncJobService } from '@recruitee/async-job-data';
import type { BulkOfferResponse } from '@recruitee/bulk-actions-types';
import { HttpApiService } from '@recruitee/http';

export interface Ids {
  ids: number[];
}

@Injectable({ providedIn: 'root' })
export class BulkActionsHttpClient {
  constructor(
    protected httpApi: HttpApiService,
    protected asyncJob: AsyncJobService,
  ) {}

  public follow({ ids }: Ids): Observable<BulkOfferResponse> {
    return this.httpApi.patch(`/bulk/offers/follow`, null, { offers_ids: ids });
  }

  public unfollow({ ids }: Ids): Observable<BulkOfferResponse> {
    return this.httpApi.patch(`/bulk/offers/unfollow`, null, { offers_ids: ids });
  }

  public deleteArchived({ ids }: Ids): Observable<BulkOfferResponse> {
    return this.httpApi.patch(`/bulk/offers/delete_archived`, null, { offers_ids: ids });
  }

  public retrieveArchived({ ids }: Ids): Observable<BulkOfferResponse> {
    return this.httpApi.patch(`/bulk/offers/retrieve_archived`, null, { offers_ids: ids });
  }

  public enableReferrals({ ids }: Ids): Observable<BulkOfferResponse> {
    return this.httpApi.patch('/bulk/offers/enable_referral_program', null, { offers_ids: ids });
  }

  public disableReferrals({ ids }: Ids): Observable<BulkOfferResponse> {
    return this.httpApi.patch('/bulk/offers/disable_referral_program', null, { offers_ids: ids });
  }
}
